/**
 * @enum
 * This is case sensitive. Please make sure the values are the same as the ones in the database.
 */
const CheckpointResponseTypes = Object.freeze({
	Comment: 'Comment',
	Time: 'Time',
	Status: 'Status',
	Dropdown: 'Dropdown',
	Attachment: 'Attachment',
	Signature: 'Signature',
	DropdownMultiSelect: 'DropdownMultiSelect',
	Datetime: 'Datetime',
});

export default CheckpointResponseTypes;
